import React from "react";
import * as XLSX from "xlsx";
import { FaRegFileExcel } from "react-icons/fa";
import { Button } from "@mui/material";

export default function ExportToExcelBTN2({ data = [] }) {
  const handleDownload = () => {
    if (
      !Array.isArray(data) ||
      data.length === 0 ||
      typeof data[0] !== "object"
    ) {
      console.error("Invalid data format. Expected an array of objects.");
      return;
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "table_data.xlsx");
    // console.log("DATA", data);
  };

  return (
    <Button
      onClick={handleDownload}
      sx={{
        backgroundColor: "#4CAF50", // Excel green color
        color: "white",
        padding: "8px 16px",
        borderRadius: "4px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Adding shadow
        "&:hover": {
          backgroundColor: "#45a049", // Darker green on hover
          boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.2)", // Stronger shadow on hover
        },
      }}
    >
      <FaRegFileExcel size={18} />
    </Button>
  );
}
